import { api } from '../../../utils/client';
import type { AiGeneratorConfig, AiModelOption, AiPromptTemplate } from '../../aitest/types';

export function listAdminAiModels(generatorKey?: string) {
  const qs = generatorKey ? `?generator_key=${encodeURIComponent(generatorKey)}` : '';
  return api<AiModelOption[]>(`/api/admin/ai-models/${qs}`);
}

export function patchAdminAiModel(id: number, payload: Partial<AiModelOption>) {
  return api<AiModelOption>(`/api/admin/ai-models/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function refreshAiModels() {
  return api('/api/ai-test/models/refresh/', { method: 'POST' });
}

export function listAdminGeneratorConfigs(generatorKey?: string) {
  const qs = generatorKey ? `?generator_key=${encodeURIComponent(generatorKey)}` : '';
  return api<AiGeneratorConfig[]>(`/api/admin/ai-generator-configs/${qs}`);
}

export function saveAdminGeneratorConfig(payload: Partial<AiGeneratorConfig> & { generator_key: string }) {
  return api<AiGeneratorConfig>('/api/admin/ai-generator-configs/', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function patchAdminGeneratorConfig(id: number, payload: Partial<AiGeneratorConfig>) {
  return api<AiGeneratorConfig>(`/api/admin/ai-generator-configs/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function listAdminPromptTemplates(generatorKey?: string) {
  const qs = generatorKey ? `?generator_key=${encodeURIComponent(generatorKey)}` : '';
  return api<AiPromptTemplate[]>(`/api/admin/ai-prompt-templates/${qs}`);
}
